var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("tests.self-evaluation-tests.title")))])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "neu-cards-ctn", attrs: { cols: "1", "cols-xl": "4" } },
        _vm._l(_vm.tests, function(test) {
          return _c("PatientPanelServiceBlock", {
            key: test.id,
            attrs: {
              visible: "",
              id: test.id,
              title: test.title,
              action: function() {
                return test.action()
              },
              img: test.img,
              only360Users: test.only360Users
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "footer",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57b9e076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b9e076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/SelfEvaluationTestBlockMenu.vue
// module id = 4148
// module chunks = 82